import React, { ReactElement } from 'react';

import { WEB_APP_SIGNUP_URL } from '../../../../../globals';
import { Assets } from '../../../../../utils/assets';
import MaxWidth from '../../../../shared/MaxWidth';
import { SOCIAL_CARDS } from '../../constants';
import { FAQ } from '../FAQ';
import { SocialCard } from '../SocialCard';
import * as S from './Content.styles';

export const Content = (): ReactElement => {
  const handleClickCta = () => {
    window.location.href = WEB_APP_SIGNUP_URL;
  };

  return (
    <S.Wrapper>
      <S.PersonalizedSection>
        <MaxWidth>
          <S.StimulateSection>
            <S.SectionTextContainer>
              <S.MobileStimulateImageWrapper>
                <S.Image alt="" src="https://cdn.brain.fm/images/procrastination/door.webp" />
              </S.MobileStimulateImageWrapper>
              <S.SectionTitle>Getting started shouldn&apos;t be hard</S.SectionTitle>
              <S.SectionDescription>
                Science makes it easy. Music makes it fun. What could you achieve, if you could
                focus on demand? Find out with Brain.fm.
              </S.SectionDescription>
              <S.ButtonLink onClick={handleClickCta}>
                <span>FEEL THE DIFFERENCE</span>
                <img alt="arrow" src="https://cdn.brain.fm/icons/arrow-right.svg" />
              </S.ButtonLink>
            </S.SectionTextContainer>
            <S.StimulateImageWrapper>
              <S.Image alt="" src="https://cdn.brain.fm/images/procrastination/door.webp" />
            </S.StimulateImageWrapper>
          </S.StimulateSection>
          <S.StimulateSection>
            <S.StimulateImageWrapper>
              <S.Image alt="" src="https://cdn.brain.fm/images/procrastination/circle.webp" />
            </S.StimulateImageWrapper>
            <S.SectionTextContainer>
              <S.MobileStimulateImageWrapper>
                <S.Image alt="" src="https://cdn.brain.fm/images/procrastination/circle.webp" />
              </S.MobileStimulateImageWrapper>
              <S.SectionTitle>Break the cycle with Brain.fm</S.SectionTitle>
              <S.SectionDescription>
                Do you know what you need to do, but aren’t doing it? You need an extra push, a bit
                more energy, to help you get started on your tasks.
              </S.SectionDescription>
              <S.ButtonLink onClick={handleClickCta}>
                <span>GET ENERGIZED</span>
                <img alt="arrow" src="https://cdn.brain.fm/icons/arrow-right.svg" />
              </S.ButtonLink>
            </S.SectionTextContainer>
          </S.StimulateSection>
          <S.LeftBlurImage
            alt={Assets.images.adhdLeftBlur.alt}
            src={Assets.images.adhdLeftBlur.url}
          />

          <S.StimulateSection>
            <S.SectionTextNarrowContainer>
              <S.MobileStimulateImageWrapper>
                <S.DeskBgImage
                  alt=""
                  src="https://cdn.brain.fm/images/procrastination/desk_bg.webp"
                />
                <S.Image alt="" src="https://cdn.brain.fm/images/procrastination/desk_no_bg.webp" />
              </S.MobileStimulateImageWrapper>
              <S.SectionTitle>Music made for motivation</S.SectionTitle>
              <S.SectionDescription>
                Exciting and upbeat, yet not distracting, Brain.fm’s Motivation Mode is built from
                the ground up to kickstart your productivity.
              </S.SectionDescription>
              <S.BadgeImage src="https://cdn.brain.fm/images/procrastination/NSF.webp" />
              <S.ButtonLink onClick={handleClickCta}>
                <span>FOCUS WITH SCIENCE</span>
                <img alt="arrow" src="https://cdn.brain.fm/icons/arrow-right.svg" />
              </S.ButtonLink>
            </S.SectionTextNarrowContainer>
            <S.StimulateImageWiderWrapper>
              <S.DeskBgImage
                alt=""
                src="https://cdn.brain.fm/images/procrastination/desk_bg.webp"
              />
              <S.Image alt="" src="https://cdn.brain.fm/images/procrastination/desk_no_bg.webp" />
            </S.StimulateImageWiderWrapper>
          </S.StimulateSection>
        </MaxWidth>
      </S.PersonalizedSection>
      <MaxWidth>
        <S.HowItWorksSection>
          <S.HowItWorksImageWrapper>
            <S.Image
              alt={Assets.images.adhdHowItWorks.alt}
              src={Assets.images.adhdHowItWorks.url}
            />
          </S.HowItWorksImageWrapper>
          <S.HowItWorksContent>
            <S.SectionTitle>How it works</S.SectionTitle>
            <S.StepsContainer>
              <S.StepItem>
                <S.StepImage alt="" src="https://cdn.brain.fm/images/procrastination/tasks.png" />
                <S.StepContent>
                  <S.StepTitle>Choose a task</S.StepTitle>
                  <S.StepDescription>What specific task do you want to do?</S.StepDescription>
                </S.StepContent>
              </S.StepItem>
              <S.StepItem>
                <S.StepImage alt="" src="https://cdn.brain.fm/images/procrastination/thunder.png" />
                <S.StepContent>
                  <S.StepTitle>Start Motivation Mode in the app</S.StepTitle>
                  <S.StepDescription>
                    Don’t start work yet! Plan your first steps.
                  </S.StepDescription>
                </S.StepContent>
              </S.StepItem>
              <S.StepItem>
                <S.StepImage alt="" src="https://cdn.brain.fm/images/procrastination/clock.png" />
                <S.StepContent>
                  <S.StepTitle>After 5 minutes, start working</S.StepTitle>
                  <S.StepDescription>
                    Take your first steps when you feel energized!
                  </S.StepDescription>
                </S.StepContent>
              </S.StepItem>
            </S.StepsContainer>
            <S.ButtonLink onClick={handleClickCta}>
              <span>GET STARTED NOW</span>
              <img alt="arrow" src="https://cdn.brain.fm/icons/arrow-right.svg" />
            </S.ButtonLink>
          </S.HowItWorksContent>
        </S.HowItWorksSection>
        <S.SocialSection>
          <S.SectionTitle>Join 1M+ self-starters...</S.SectionTitle>
          <S.SectionDescription style={{ textAlign: 'center' }}>
            Our users win the day, everyday — see what they have to say!
          </S.SectionDescription>
          <S.SocialCardsWrapper>
            {SOCIAL_CARDS.map((card, index) => (
              <SocialCard
                key={index}
                description={card.description}
                name={card.name}
                profileImageUrl={card.profileImageUrl}
                username={card.username}
              />
            ))}
          </S.SocialCardsWrapper>
          <S.ButtonLink onClick={handleClickCta}>
            <span>HEAR IT FOR YOURSELF</span>
            <img alt="arrow" src="https://cdn.brain.fm/icons/arrow-right.svg" />
          </S.ButtonLink>
        </S.SocialSection>
      </MaxWidth>

      <MaxWidth>
        <S.FAQSection>
          <FAQ />
        </S.FAQSection>
      </MaxWidth>
    </S.Wrapper>
  );
};
